<template>
  <div class="card card-xl-stretch mb-xl-8">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bold fs-3 mb-1">Acesso rápido</span>
        <span class="text-muted fw-semibold fs-7"
          >Módulos utilizados recentemente</span
        >
      </h3>
      <div class="card-toolbar"></div>
    </div>
    <div class="card-body p-0 d-flex flex-column">
      <div class="card-px pt-5 pb-10 flex-grow-1">
        <div class="row m-0">
          <router-link
            to="/movimentacao/faturamento/editar"
            class="col bg-light-primary px-6 py-8 rounded-2 me-7 mb-7"
          >
            <span class="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
              <inline-svg src="media/icons/duotune/ecommerce/ecm008.svg" />
            </span>
            <a class="text-primary fw-semobold fs-6">
              Novo Faturamento
            </a></router-link
          >
          <router-link
            to="/cadastros/clientes/editar"
            class="col bg-light-info px-6 py-8 rounded-2 mb-7"
          >
            <span class="svg-icon svg-icon-3x svg-icon-info d-block my-2">
              <inline-svg src="media/icons/duotune/communication/com005.svg" />
            </span>
            <a href="#" class="text-info fw-semobold fs-6">
              Adicionar Cliente
            </a></router-link
          >
        </div>
        <div class="row m-0">
          <router-link
            to="/cadastros/produtos/editar"
            class="col bg-light-danger px-6 py-8 rounded-2 me-7 mb-7"
          >
            <span class="svg-icon svg-icon-3x svg-icon-danger d-block my-2">
              <inline-svg src="media/icons/duotune/ecommerce/ecm009.svg" />
            </span>
            <a href="#" class="text-danger fw-semobold fs-6">
              Adicionar produto
            </a></router-link
          >
          <router-link
            to="/cadastros/transportadoras/editar"
            class="col bg-light-secondary px-6 py-8 rounded-2 mb-7"
          >
            <span
              class="svg-icon svg-icon-3x svg-icon-active-secondary d-block my-2"
            >
              <inline-svg src="media/icons/duotune/ecommerce/ecm006.svg" />
            </span>
            <a href="#" class="text-inverse-secondary fw-semobold fs-6">
              Adicionar Transportadora
            </a></router-link
          >
        </div>
        <div class="row m-0">
          <router-link
            to="/movimentacao/gerenciarNFe/gerenciarnfe"
            class="col bg-light-success px-6 py-8 rounded-2 me-7 mb-7"
          >
            <span class="svg-icon svg-icon-3x svg-icon-success d-block my-2">
              <inline-svg src="media/icons/duotune/abstract/abs007.svg" />
            </span>
            <a href="#" class="text-success fw-semobold fs-6">
              Gerenciar NF-e
            </a></router-link
          >
          <router-link
            to="/cadastros/produtos/consultar"
            class="col bg-light-primary px-6 py-8 rounded-2 mb-7"
          >
            <span class="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
              <inline-svg src="media/icons/duotune/general/gen004.svg" />
            </span>
            <a href="#" class="text-primary fw-semobold fs-6">
              Consultar Produtos
            </a></router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    widgetColor: { type: String, required: false, default: "danger" },
    widgetClasses: {
      type: String,
      required: false,
      default: "card-xl-stretch mb-xl-8",
    },
    chartHeight: { type: Number, required: false, default: 0 },
  },
  data() {
    return {
      loading: false,
      items: [],
    };
  },
};
</script>

<style lang="scss" scoped></style>
